import { deleteCallScorecardDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteCallScorecardCallable = getCallable(
  deleteCallScorecardDefinition,
);
